/* ──────────────────────────────────────────────────────────
   StockPicker — react-select JS style overrides
   Uses design tokens from variables.css
   ────────────────────────────────────────────────────────── */

export const stockPickerStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 42,
    borderRadius: 8,
    borderColor: state.isFocused ? "#210F47" : "#dadce0",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(33, 15, 71, 0.15)" : "none",
    fontFamily: "'Google Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#210F47" : "#c4c7c5",
    },
    cursor: "text",
  }),

  placeholder: (base) => ({
    ...base,
    color: "#80868b",
    fontSize: 14,
  }),

  input: (base) => ({
    ...base,
    color: "#202124",
    fontSize: 14,
  }),

  menu: (base) => ({
    ...base,
    borderRadius: 8,
    border: "1px solid #dadce0",
    boxShadow: "0 2px 8px rgba(60, 64, 67, 0.12)",
    overflow: "hidden",
    marginTop: 4,
    zIndex: 200,
  }),

  menuList: (base) => ({
    ...base,
    padding: 0,
    maxHeight: 260,
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? "#210F47" : "#80868b",
    padding: "8px 10px",
    "&:hover": {
      color: "#210F47",
    },
  }),

  clearIndicator: (base) => ({
    ...base,
    color: "#80868b",
    padding: "8px 6px",
    cursor: "pointer",
    "&:hover": {
      color: "#ea4335",
    },
  }),

  singleValue: (base) => ({
    ...base,
    color: "#202124",
    fontSize: 14,
  }),

  valueContainer: (base) => ({
    ...base,
    padding: "2px 12px",
  }),
};

export const stockPickerTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: "#210F47",
    primary75: "#3a1a8c",
    primary50: "#EDE9FF",
    primary25: "#f5f3ff",
    danger: "#ea4335",
    dangerLight: "#fce8e6",
  },
});
